<template>
  <div class="ba">
    <v-menu v-model="assignMenu" offset-y :close-on-content-click="false" min-width="300">
      <template #activator="{ on }">
        <button type="button" class="ba__btn" v-on="on"><v-icon x-small>mdi-account-switch-outline</v-icon>{{ $t('crmAssign') }}</button>
      </template>
      <div class="ba__panel">
        <crm-user-picker v-model="assignTo" title="crmOwner" />
        <v-btn small depressed color="primary" class="mt-3" :disabled="!assignTo" @click="assignMenu = false; run('assign', { owner_user_id: assignTo })">{{ $t('crmApply') }}</v-btn>
      </div>
    </v-menu>
    <v-menu v-if="entity === 'lead'" offset-y>
      <template #activator="{ on }">
        <button type="button" class="ba__btn" v-on="on"><v-icon x-small>mdi-flag-outline</v-icon>{{ $t('crmStatus') }}</button>
      </template>
      <v-list dense>
        <v-list-item v-for="s in leadStatuses" :key="s.key" @click="run('status', { status: s.key })">
          <span class="ba__dot" :style="{ background: s.color }" />{{ s.title || $t('crmStatus_' + s.key) }}
        </v-list-item>
      </v-list>
    </v-menu>
    <v-menu v-if="entity === 'deal' && stages.length" offset-y>
      <template #activator="{ on }">
        <button type="button" class="ba__btn" v-on="on"><v-icon x-small>mdi-arrow-left-bold-box-outline</v-icon>{{ $t('crmStage') }}</button>
      </template>
      <v-list dense>
        <v-list-item v-for="s in stages.filter(x => x.kind === 'open')" :key="s.id" @click="run('stage', { stage_id: s.id })">{{ s.title }}</v-list-item>
      </v-list>
    </v-menu>
    <v-menu offset-y>
      <template #activator="{ on }">
        <button type="button" class="ba__btn" v-on="on"><v-icon x-small>mdi-chevron-triple-up</v-icon>{{ $t('crmPriority') }}</button>
      </template>
      <v-list dense>
        <v-list-item v-for="p in priorities" :key="p" @click="run('priority', { priority: p })">{{ $t('crmPriority_' + p) }}</v-list-item>
      </v-list>
    </v-menu>
    <button type="button" class="ba__btn" @click="tag"><v-icon x-small>mdi-tag-outline</v-icon>{{ $t('crmAddTag') }}</button>
    <button type="button" class="ba__btn" @click="followUp"><v-icon x-small>mdi-calendar-plus</v-icon>{{ $t('crmFollowUp') }}</button>
    <button type="button" class="ba__btn" @click="run('archive', {})"><v-icon x-small>mdi-archive-outline</v-icon>{{ $t('crmArchive') }}</button>
    <v-progress-circular v-if="busy" :size="16" :width="2" indeterminate color="primary" />
  </div>
</template>

<script>
import api, { crmError } from '../crmApi'
import CrmUserPicker from './CrmUserPicker'
import { crm, PRIORITIES, leadStatuses, nowSql } from '../crmStore'

export default {
  name: 'CrmBulkActions',
  components: { CrmUserPicker },
  inject: ['shell'],
  props: { entity: String, ids: { type: Array, default: () => [] }, pipelineId: { type: Number, default: null } },
  data: () => ({ busy: false, assignMenu: false, assignTo: null }),
  computed: {
    priorities () { return PRIORITIES },
    leadStatuses () { return leadStatuses().filter(s => s.category === 'open') },
    stages () {
      const p = crm.pipelines.find(x => x.id === this.pipelineId)
      return p ? p.stages || [] : []
    }
  },
  methods: {
    async tag () {
      const t = await this.shell.ask(this.$t('crmAddTag'), this.$t('crmTag'))
      if (t) this.run('add_tag', { tags: [t] })
    },
    async followUp () {
      const t = await this.shell.ask(this.$t('crmFollowUp'), this.$t('crmActTitle'), this.$t('crmFollowUp'))
      if (t) this.run('follow_up', { due_at: nowSql(1, 10), type: 'call', title: t })
    },
    async run (action, payload) {
      this.busy = true
      try {
        const res = await api.bulk(action, { entity_type: this.entity, ids: this.ids, payload })
        const failed = (res && res.failed) || []
        this.shell.toast(this.$t('crmBulkDone', { n: (res && res.updated) || 0 }) + (failed.length ? ' · ' + this.$t('crmBulkFailed', { n: failed.length }) : ''), {
          error: !!failed.length,
          undo: action === 'archive' ? () => api.bulk('unarchive', { entity_type: this.entity, ids: this.ids, payload: {} }).then(() => this.$emit('done')) : null
        })
        this.$emit('done')
      } catch (e) {
        this.shell.toast(crmError(e).message, { error: true })
      } finally {
        this.busy = false
      }
    }
  }
}
</script>

<style scoped>
.ba { display: flex; flex-wrap: wrap; align-items: center; gap: 6px; }
.ba__btn { display: inline-flex; align-items: center; gap: 4px; height: 28px; padding: 0 10px; border-radius: 6px; background: #fff; border: 1px solid rgba(25, 118, 210, .25); font-size: .76rem; font-weight: 600; }
.theme--dark .ba__btn { background: #1e1e1e; }

.ba__panel { background: #fff; padding: 14px; border-radius: 6px; }
.theme--dark .ba__panel { background: #1e1e1e; }
.ba__dot { width: 8px; height: 8px; border-radius: 50%; margin-inline-end: 8px; }
.ba__btn:hover { border-color: var(--v-primary-base); }
</style>
